import React from 'react';

import type { IGigComplianceRow } from '@/components/agent/gig-compliance/types';
import type { ISetAdherenceReasonRequest } from '@/api/types';
import type { IContractRequirement } from '@/store/types';

import { Container } from '@/components/agent/gig-compliance/ComplianceTable.styles';
import { EarlyCard, LateCard, NoShowsCard, ReasonsCard, RequirementsCard, WeeksRangePicker } from '@/components/common';
import { MONTH_FULL_DAY_YEAR_FORMAT } from '@/config/variables';
import { WeeksCard } from '@/components/agent/gig-compliance';
import { COMPLIANCE_CONFIG_TABLE } from '@/constants/contracts';

interface IProps {
  rowsToDisplay: IGigComplianceRow[];
  requirements: IContractRequirement | undefined;
  handleSaveReason: (
    payload: Omit<ISetAdherenceReasonRequest, 'contractId' | 'selectedWeekId'>,
    closeModal: () => void,
  ) => void;
  isMobileScreenSize: boolean;
  alwaysShowMobileView?: boolean;
  isLoading: boolean;
}

const BaseComplianceTable = ({
  rowsToDisplay,
  requirements,
  handleSaveReason,
  isMobileScreenSize,
  alwaysShowMobileView,
  isLoading,
}: IProps): React.ReactElement => {
  isLoading = isLoading ?? false;

  return (
    <Container className={alwaysShowMobileView ? 'show-mobile-view' : 'show-default-view'}>
      {(isMobileScreenSize || alwaysShowMobileView) && (
        <WeeksRangePicker showDaySpanSelect={false} dateFormat={{ end: MONTH_FULL_DAY_YEAR_FORMAT }} />
      )}
      <WeeksCard tableConfig={COMPLIANCE_CONFIG_TABLE} rowsToDisplay={rowsToDisplay} />
      <RequirementsCard
        requirements={requirements}
        tableConfig={COMPLIANCE_CONFIG_TABLE}
        rowsToDisplay={rowsToDisplay}
        isLoading={isLoading}
      />
      <NoShowsCard rowsToDisplay={rowsToDisplay} isLoading={isLoading} />
      <LateCard rowsToDisplay={rowsToDisplay} isLoading={isLoading} alwaysShowMobileView={alwaysShowMobileView} />
      <EarlyCard rowsToDisplay={rowsToDisplay} isLoading={isLoading} />

      <ReasonsCard rowsToDisplay={rowsToDisplay} handleSaveReason={handleSaveReason} isLoading={isLoading} />
    </Container>
  );
};

export { BaseComplianceTable };
